module.exports = __webpack_public_path__ + "static/media/pix.68d92f5f.png";